export const SECTION_TAB_INDEX = {
    MACRO_TAB: 0,
    MICRO_TAB: 1,
    ASSAYS_EVALUATION_TAB: 2,
    SUBPORTION_TAB: 3,
    DIAGNOSIS_TAB: 4,
    ADDITIONAL_TAB: 5,
    CODIFICATIONS_TAB: 6,
    OBSERVATIONS_TAB: 7,
    SAMPLE_TAB: 8
}
